{
  "name": "rezeptsammlungng",
  "version": "1.0.0",
  "license": "MIT",
  "scripts": {
    "preinstall": "npx only-allow pnpm",
    "ng": "ng",
    "start": "ng serve -o",
    "build": "ng build",
    "test": "ng test --watch=false",
    "test:watch": "ng test",
    "lint": "ng lint",
    "updateBuildTimeStamp": "node ./updateBuildTimeStamp.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.2.3",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/forms": "22.2.3",
    "@angular/localize": "^22.2.3",
    "@angular/platform-browser": "22.2.3",
    "@angular/platform-browser-dynamic": "22.2.3",
    "@angular/router": "22.2.3",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@popperjs/core": "^2.11.8",
    "ajv": "^8.20.0",
    "angular-typed-router": "^2.0.0",
    "bootstrap": "^5.3.8",
    "core-js": "^3.51.0",
    "rxjs": "^7.8.2",
    "tether": "^3.0.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.6.0",
    "@angular/build": "^22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/language-service": "22.2.3",
    "@eslint/js": "^10.0.1",
    "@types/node": "^26.6.5",
    "@vitest/coverage-v8": "^5.0.5",
    "angular-cli-ghpages": "^3.1.2",
    "angular-eslint": "22.6.0",
    "baseline-browser-mapping": "^2.11.30",
    "cypress": "^16.2.0",
    "eslint": "^10.13.0",
    "happy-dom": "^21.0.4",
    "istanbul-lib-instrument": "^6.0.3",
    "moment-timezone": "^0.6.5",
    "replace-in-file": "9.0.0",
    "ts-node": "^10.9.2",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.72.0",
    "vitest": "^5.0.5"
  }
}
